import axios from "axios";
import times from "./times";
import featuredItem from "./featuredItem";
import otherContents from "./otherContents";
import articles from "./articles";
import otherVideoContents from "./otherVideoContents";
import auth from "./auth";
import themes from "./themes";
import * as Cookie from "universal-cookie";
import fourm from "./fourm";
import ngo from "./ngo";
import ngoarticles from "./ngoarticles";
import articles_blog from "./articles_blog";
import Products from "./products";
import categoeries from "./categories";
import comments from "./comments";
import soulsaraVideoContents from "./soulsaraVideoContents";
import webinar from "./webinar";
import oca from "./oca";
import rolesandpermissions from "./roles-and-permissions";

const cookie = new Cookie.default();

// Helper function to get current token
const getCurrentToken = () => {
  return cookie.get("userAuthTokenAdmin") || "";
};

const jsonApi = axios.create({
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});

const formDataApi = axios.create({
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

// Add request interceptor to dynamically set authorization header
jsonApi.interceptors.request.use(
  function (config) {
    const token = getCurrentToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add request interceptor for form data API
formDataApi.interceptors.request.use(
  function (config) {
    const token = getCurrentToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors
jsonApi.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response?.status === 401) {
      // Token might be expired, clear it and redirect to login
      cookie.remove("userAuthTokenAdmin", { path: "/" });
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

formDataApi.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response?.status === 401) {
      // Token might be expired, clear it and redirect to login
      cookie.remove("userAuthTokenAdmin", { path: "/" });
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

const timesSVC = times(jsonApi);
const themesSVC = themes(jsonApi);
const featuredItemSVC = featuredItem(formDataApi);
const otherContentsSVC = otherContents(formDataApi);
const articlesSVC = articles(formDataApi);
const otherVideoContentsSVC = otherVideoContents(formDataApi);
const authSVC = auth(jsonApi, formDataApi, formDataApi);
const fourmSVC = fourm(jsonApi);
const ngoSVC = ngo(formDataApi);
const ngoarticlesSVC = ngoarticles(formDataApi);
const webinarSVC = webinar(formDataApi);
const ocaSVC = oca(jsonApi);
const blogshop = articles_blog(formDataApi);
const productsSVC = Products(formDataApi);
const categorySVC = categoeries(jsonApi);
const commentsSVC = comments(jsonApi);
const soulsaraVideoContentsSVC = soulsaraVideoContents(formDataApi);
const roleandpermissions = rolesandpermissions(jsonApi);

export {
  ocaSVC,
  webinarSVC,
  soulsaraVideoContentsSVC,
  categorySVC,
  commentsSVC,
  fourmSVC,
  timesSVC,
  featuredItemSVC,
  otherContentsSVC,
  articlesSVC,
  otherVideoContentsSVC,
  authSVC,
  themesSVC,
  ngoSVC,
  ngoarticlesSVC,
  blogshop,
  productsSVC,
  roleandpermissions,
};
